'use client'
import FaqsList from '@/components/faqs/FaqsList'
import { Category, FAQ_CATEGORIES } from '@/sanity/lib/types'
import { useState } from 'react'
import Accordion from '@/components/Accordion'

export default function MobileFAQLayout() {
  const [activeCategory, setActiveCategory] = useState<Category | null>(null)

  return (
    <div className="flex w-full flex-col items-center gap-3.5 lg:hidden">
      {FAQ_CATEGORIES.map((category, i) => (
        <Accordion
          key={i}
          title={category}
          isOpen={activeCategory === category}
          onToggle={() =>
            setActiveCategory(activeCategory === category ? null : category)
          }
        >
          <FaqsList
            key={category}
            category={category}
            isOpen={activeCategory === category}
          />
        </Accordion>
      ))}
    </div>
  )
}
